import { FC } from 'react';
import supplierCreated from '../../assets/supplierCreated.svg';
import { CalendarSvg } from '../../components/Icons/CalendarIcon';
import { ClockIcon } from '../../components/Icons/ClockIcon';

export interface PitchSlotConfirmedSuccessProps {
    dateLabel: string;
    timeRange: string;
}

export const PitchSlotConfirmedSuccess: FC<PitchSlotConfirmedSuccessProps> = ({ dateLabel, timeRange }) => (
    <div className="SupplierCompanyPitches__success success">
        <div className="success__block">
            <div className="pitch-slot-confirmed">
                <h1 className="pitch-slot-confirmed__title">Pitch Slot Confirmed</h1>

                <div className="pitch-slot-confirmed__body">
                    <p className="pitch-slot-confirmed__lead">Your new pitch slot has been successfully confirmed:</p>

                    <div className="pitch-slot-confirmed__slot-box">
                        <div className="pitch-slot-confirmed__meta">
                            <CalendarSvg fill="#001965" className="" />
                            <span className="pitch-slot-confirmed__meta-text">{dateLabel}</span>
                        </div>
                        <div className="pitch-slot-confirmed__meta">
                            <ClockIcon fill="#001965" />
                            <span className="pitch-slot-confirmed__meta-text">{timeRange}</span>
                        </div>
                    </div>

                    <p className="pitch-slot-confirmed__text">The Customer has been notified.</p>
                    <p className="pitch-slot-confirmed__text">We look forward to your presentation.</p>
                </div>

                <div className="pitch-slot-confirmed__contact">
                    <p className="pitch-slot-confirmed__contact-line">
                        <span>If you have any questions, please contact the support team at </span>
                        <a href="mailto:support@askproco.com" className="pitch-slot-confirmed__link">
                            support@askproco.com
                        </a>
                    </p>
                    <p className="pitch-slot-confirmed__contact-line">
                        <span>or contact us directly at </span>
                        <span className="pitch-slot-confirmed__phone">+27 (0) 21 565 0401</span>
                    </p>
                </div>
            </div>
        </div>
        <img src={supplierCreated} className="image__item" alt="" />
    </div>
);
